import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

/**
 * POSLayout Component
 * Dedicated full-screen layout for POS system without any app chrome
 * Provides true 100vh coverage without headers, padding, or other constraints
 */
const POSLayout = ({ children }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: theme.palette.background.default,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1,
      }}
    >
      {children}
    </Box>
  );
};

export default POSLayout;
